// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4e5c67cb","455":"69cd04c1","977":"c8476f68"}[chunkId] + ".chunk.js";
};